/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Modal, Button } from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import callAPI from '@/api/callAPI';
import '../styles.scss';
import styles from '../Node/styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  showModal: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
};

class ResetModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModal,
      id: props.id,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.gateway.reset');
    this.submiteReset = this.submiteReset.bind(this);
  }

  componentWillReceiveProps({ showModal, id }) {
    if (showModal !== this.props.showModal) {
      this.setState({ showModal });
    }
    if (id !== this.props.id) {
      this.setState({ id });
    }
  }

  submiteReset() {
    const { id } = this.state;

    this.setState({ resetStatus: 'pending' });

    callAPI({
      endpoint: `/tdmng/gateways/${id}/ctrl/reset`,
      method: 'POST',
    }).then(() => {
      this.setState({ resetStatus: 'success' });

      _.delay(() => {
        this.setState({ resetStatus: '' });
        this.props.onCancel();
      }, 1000);
    }).catch(() => {
      this.setState({ resetStatus: 'failure' });

      _.delay(() => {
        this.setState({ resetStatus: '' });
      }, 1000);
    });
  }

  render() {
    const { showModal, resetStatus } = this.state;

    return (
      <Modal
        bsClass="aisz-modal-warning"
        backdrop="static"
        show={showModal}
        onHide={this.props.onCancel}
      >
        <Modal.Header closeButton>
          {this.intlMsg.msg('title')}
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">{this.intlMsg.msg('content')}</div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <Button
              bsStyle="aisz-default"
              onClick={this.props.onCancel}
              className={styles.white}
            >
              {this.intlMsg.msg('cancel')}
            </Button>
            <Button
              bsStyle="aisz-warning"
              onClick={this.submiteReset}
              disabled={resetStatus === 'pending'}
            >
              {resetStatus === 'pending' && <i className="fa fa-spin fa-spinner m-r-s" />}
              {this.intlMsg.msg('confirm')}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

ResetModal.propTypes = propTypes;

export default injectIntl(ResetModal);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/Gateway/ResetModal.jsx